/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import { useState, memo } from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';

// Local Definitions
import "./styles.scss";
import { Rating } from "./common";
import { FormLabel } from "../../common";
const baseClassName = styleNames.base;
const componentClassName = 'ratings-input';

/**
 * This is the component description.
 */
const RatingsInput = ({
  id,
  className: userClassName,
  style,
  name,
  ratingCount,
  showRatingValue,
  color,
  label,
  labelColor,
  labelMax,
  labelMin,
  displayRatingsLabel,
  optional
  // ...otherProps
}) => {
  const [hover, setHover] = useState(null);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
    style: style
  }, /*#__PURE__*/React.createElement(FormLabel, {
    name: name,
    color: labelColor,
    optional: optional
    // {...otherProps}
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "stars"
  }, displayRatingsLabel && /*#__PURE__*/React.createElement("p", {
    className: "label-text s-2 x-metadata c-x"
  }, labelMin), [...Array(ratingCount)].map((_, index) => {
    const ratingValue = index + 1;
    return /*#__PURE__*/React.createElement(Rating, {
      key: ratingValue,
      ratingId: `${name}-${ratingValue}`,
      value: ratingValue,
      name: name,
      hover: hover,
      setHover: setHover,
      showRatingValue: showRatingValue,
      activeBackgroundColor: color
    });
  }), displayRatingsLabel && /*#__PURE__*/React.createElement("p", {
    className: "label-text s-2 x-metadata c-x"
  }, labelMax)));
};
RatingsInput.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The number of ratings input stars to be displayed
   */
  ratingCount: PropTypes.number.isRequired,
  /**
   * Name of the rating input
   */
  name: PropTypes.string.isRequired,
  /**
   * Determines if the rating start value should be shown
   */
  showRatingValue: PropTypes.bool,
  /**
   * The label of the ratings input
   */
  label: PropTypes.string.isRequired,
  /**
   * description for the highest rating value
   */
  labelMax: PropTypes.string,
  /**
   * description for the lowest rating value
   */
  labelMin: PropTypes.string,
  /**
   * If the rating lables should be shown
   */
  displayRatingsLabel: PropTypes.bool,
  /**
   * Whether the input is optional or not
   */
  optional: PropTypes.bool,
  /**
  * The color of the stars
  */
  color: PropTypes.string,
  /**
  * String that will represent color for the label
  */
  labelColor: PropTypes.string
};
RatingsInput.defaultProps = {
  labelMin: 'not satisfied.',
  labelMax: 'very satisfied.'
};
export default /*#__PURE__*/memo(RatingsInput);